import { Card } from "../types/card";

export const cards: Card[] = [
	{
		id: "start",
		name: "Start",
		image: "card-start",
		description:
			"Karta Start je potřeba při každé kombinaci. Tato karta může být použita pouze jednou, při použití více těchto karet je zvolena ta nejčitelnější.\nČtení kódu začíná zde a končí na kartě Konec.",
	},
	{
		id: "end",
		name: "Konec",
		image: "card-end",
		description:
			"Karta Konec je potřeba při každé kombinaci. Tato karta může být použita pouze jednou, při použití více těchto karet je zvolena ta nejčitelnější.\nČtení kódu zde končí, začíná na kartě Start.",
	},
	{
		id: "step",
		name: "Krok",
		image: "card-step",
		description:
			"Karta Krok slouží k pohybu. Při použití karty se kouzelník pohne o jedno pole směrem kam se dívá.\nKouzelník se může pohybovat pouze po: prázdných polích, zabitých nepřátelích nebo konečném portálu. Když kouzelník přejde na konečný portál, je pokus ihned ukončen. Když se kouzelník pokusí přejít na nedovolené pole, je pokus vyhodnocen jako nevydařený.",
	},
	{
		id: "rotation_l",
		name: "Otoč vlevo",
		image: "card-rotation-l",
		description: "Karta Otoč vlevo otáčí kouzelníka doleva.",
	},
	{
		id: "rotation_r",
		name: "Otoč vpravo",
		image: "card-rotation-r",
		description: "Karta Otoč vpravo otáčí kouzelníka doprava.",
	},
	{
		id: "loot",
		name: "Sebrat",
		image: "card-loot",
		description:
			"Karta Seber dává kouzelníkovi příkaz k sebrání věci.\nPokud se před kouzelníkem nachází truhla, je následně vybrána. Pokud se před kouzelníkem truhla nenachází, je pokus vyhodnocen jako nevydařený. Po již vybrané truhle nejde chodit, musí být obejita.",
	},
	{
		id: "attack",
		name: "Útok",
		image: "card-attack",
		description:
			"Karta Útok dovoluje kouzelníkovi zaútočit na nepřítele.\nPokud se před kouzelníkem nachází nepřítel, je zabit. Pokud se před kouzelníkem nenachází nepřítel, je pokus vyhodnocen jako nevydařený. Oproti kartičce Sebrat se dá chodit po tomto poli.",
	},
	{
		id: "for",
		name: "Opakuj",
		image: "card-for",
		description:
			"Karta Opakuj opakuje určitou činnost několikrát. Karta se musí rozšiřovat o 2 karty - číslo, kolikrát se má činnost opakovat a co se má stát.\nPro počet opakování se používají kartičky Číslo 1 až 5. Pro akci co se má stát se dá použít: Krok, Otoč vlevo nebo Otoč vpravo.\nPokud tyto kartičky chybí nebo jsou ve špatném pořadí, je pokus vyhodnocen jako nevydařený.",
	},
	{
		id: "num_1",
		name: "Číslo 1",
		image: "card-num-1",
		description: "Karta Číslo 1 určuje počet pro opakování pro 1x.",
	},
	{
		id: "num_2",
		name: "Číslo 2",
		image: "card-num-2",
		description: "Karta Číslo 2 určuje počet pro opakování pro 2x.",
	},
	{
		id: "num_3",
		name: "Číslo 3",
		image: "card-num-3",
		description: "Karta Číslo 3 určuje počet pro opakování pro 3x.",
	},
	{
		id: "num_4",
		name: "Číslo 4",
		image: "card-num-4",
		description: "Karta Číslo 4 určuje počet pro opakování pro 4x.",
	},
	{
		id: "num_5",
		name: "Číslo 5",
		image: "card-num-5",
		description: "Karta Číslo 5 určuje počet pro opakování pro 5x.",
	},
];
